import { ActionsUnion, createAction } from "../definitions";
import { DriverSeatUserActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DriverSeatUserActions = {
    set: (payload: string) => createAction(DriverSeatUserActionTypes.SET_DRIVER_SEAT_USER, payload),
    clear: () => createAction(DriverSeatUserActionTypes.CLEAR_DRIVER_SEAT_USER)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DriverSeatUserActions = ActionsUnion<typeof DriverSeatUserActions>;